import axios from 'axios';
import { API_BASE_URL } from '../config';

const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true // Важно, если используешь куки
});

export const getLogs = async (page = 1, pageSize = 50, searchTerm = '') => {
    const params = { page, page_size: pageSize };
    if (searchTerm) {
        params.search = searchTerm;
    }
    const response = await api.get('/api/logs/', { params });
    return response.data;
};